export const SIRE_COLORS = [
  { id: "red", label: "Czerwony" },
  { id: "blue", label: "Niebieski" },
  { id: "green", label: "Zielony" },
  { id: "yellow", label: "Żółty" },
  { id: "orange", label: "Pomarańczowy" },
  { id: "purple", label: "Fioletowy" },
  { id: "pink", label: "Różowy" },
  { id: "teal", label: "Turkusowy" },
  { id: "brown", label: "Brązowy" },
  { id: "black", label: "Czarny" },
] as const;

export type SireColorId = (typeof SIRE_COLORS)[number]["id"];

export function sireColorLabel(id: string | null | undefined): string {
  if (!id) {
    return "Bez koloru";
  }
  return SIRE_COLORS.find((color) => color.id === id)?.label ?? id;
}
